/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_A1Inputs */

const en_cad_faq_a1 = /** @type {(inputs: Cad_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. CADCraft is open source under MIT OR Apache-2.0 and free to use on the desktop and in the browser, with no license fee and no account required to draw. Pro cloud features on this site are optional ($4.9/month or $29/year).`)
};

/**
* | output |
* | --- |
* | "Yes. CADCraft is open source under MIT OR Apache-2.0 and free to use on the desktop and in the browser, with no license fee and no account required to draw. ..." |
*
* @param {Cad_Faq_A1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_a1 = /** @type {((inputs?: Cad_Faq_A1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_A1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_a1(inputs)
});
export { cad_faq_a1 as "cad.faq.a1" }